/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createInterviewLocationResponse } from '../models/api_createInterviewLocationResponse';
import type { api_updateInterviewLocationIsActiveRequest } from '../models/api_updateInterviewLocationIsActiveRequest';
import type { db_GetInterviewLocationRow } from '../models/db_GetInterviewLocationRow';
import type { db_InterviewInterviewLocationCommitteeMember } from '../models/db_InterviewInterviewLocationCommitteeMember';
import type { db_ListInterviewLocationsPublicRow } from '../models/db_ListInterviewLocationsPublicRow';
import type { db_ListInterviewLocationsRow } from '../models/db_ListInterviewLocationsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InterviewLocations {
    /**
     * Get a list of interview locations
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListInterviewLocationsRow OK
     * @throws ApiError
     */
    public static listInterviewLocations(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListInterviewLocationsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-locations',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new interview location
     * @param interviewLocationName
     * @param programmeId
     * @param chairSignature Chair signature file
     * @param leadSignature Lead signature file
     * @param letterhead Letterhead file
     * @param address1
     * @param address2
     * @param attendanceConfirmationEmail
     * @param attendanceConfirmationPhone
     * @param chairAffiliation
     * @param chairEmail
     * @param chairName
     * @param chairPosition
     * @param committeeMembers
     * @param consulatePocCountryCallingCode
     * @param consulatePocEmail
     * @param consulatePocName
     * @param consulatePocPhone
     * @param countryId
     * @param fcdoPostId
     * @param instructions
     * @param isOnline
     * @param leadEmail
     * @param leadName
     * @param leadPosition
     * @param municipality
     * @param postalCode
     * @param region
     * @param regionId
     * @returns api_createInterviewLocationResponse OK
     * @throws ApiError
     */
    public static createInterviewLocation(
        interviewLocationName: string,
        programmeId: number,
        chairSignature?: Blob,
        leadSignature?: Blob,
        letterhead?: Blob,
        address1?: string,
        address2?: string,
        attendanceConfirmationEmail?: string,
        attendanceConfirmationPhone?: string,
        chairAffiliation?: string,
        chairEmail?: string,
        chairName?: string,
        chairPosition?: string,
        committeeMembers?: string,
        consulatePocCountryCallingCode?: number,
        consulatePocEmail?: string,
        consulatePocName?: string,
        consulatePocPhone?: string,
        countryId?: number,
        fcdoPostId?: number,
        instructions?: string,
        isOnline?: boolean,
        leadEmail?: string,
        leadName?: string,
        leadPosition?: string,
        municipality?: string,
        postalCode?: string,
        region?: string,
        regionId?: number,
    ): CancelablePromise<api_createInterviewLocationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-locations',
            formData: {
                'chair_signature': chairSignature,
                'lead_signature': leadSignature,
                'letterhead': letterhead,
                'address_1': address1,
                'address_2': address2,
                'attendance_confirmation_email': attendanceConfirmationEmail,
                'attendance_confirmation_phone': attendanceConfirmationPhone,
                'chair_affiliation': chairAffiliation,
                'chair_email': chairEmail,
                'chair_name': chairName,
                'chair_position': chairPosition,
                'committee_members': committeeMembers,
                'consulate_poc_country_calling_code': consulatePocCountryCallingCode,
                'consulate_poc_email': consulatePocEmail,
                'consulate_poc_name': consulatePocName,
                'consulate_poc_phone': consulatePocPhone,
                'country_id': countryId,
                'fcdo_post_id': fcdoPostId,
                'instructions': instructions,
                'interview_location_name': interviewLocationName,
                'is_online': isOnline,
                'lead_email': leadEmail,
                'lead_name': leadName,
                'lead_position': leadPosition,
                'municipality': municipality,
                'postal_code': postalCode,
                'programme_id': programmeId,
                'region': region,
                'region_id': regionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of interview locations
     * @param countryId Country ID
     * @param fcdoPostId FCDO post ID
     * @returns db_ListInterviewLocationsPublicRow OK
     * @throws ApiError
     */
    public static listInterviewLocationsPublic(
        countryId?: string,
        fcdoPostId?: number,
    ): CancelablePromise<Array<db_ListInterviewLocationsPublicRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-locations/public',
            query: {
                'country_id': countryId,
                'fcdo_post_id': fcdoPostId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an interview location
     * @param id Interview location ID
     * @returns db_GetInterviewLocationRow OK
     * @throws ApiError
     */
    public static getInterviewLocation(
        id: number,
    ): CancelablePromise<db_GetInterviewLocationRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-locations/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an interview location
     * @param id Interview location ID
     * @param interviewLocationName
     * @param programmeId
     * @param chairSignature Chair signature file
     * @param leadSignature Lead signature file
     * @param letterhead Letterhead file
     * @param address1
     * @param address2
     * @param attendanceConfirmationEmail
     * @param attendanceConfirmationPhone
     * @param chairAffiliation
     * @param chairEmail
     * @param chairName
     * @param chairPosition
     * @param committeeMembers
     * @param consulatePocCountryCallingCode
     * @param consulatePocEmail
     * @param consulatePocName
     * @param consulatePocPhone
     * @param countryId
     * @param fcdoPostId
     * @param instructions
     * @param isOnline
     * @param leadEmail
     * @param leadName
     * @param leadPosition
     * @param municipality
     * @param postalCode
     * @param region
     * @param regionId
     * @returns void
     * @throws ApiError
     */
    public static updateInterviewLocation(
        id: number,
        interviewLocationName: string,
        programmeId: number,
        chairSignature?: Blob,
        leadSignature?: Blob,
        letterhead?: Blob,
        address1?: string,
        address2?: string,
        attendanceConfirmationEmail?: string,
        attendanceConfirmationPhone?: string,
        chairAffiliation?: string,
        chairEmail?: string,
        chairName?: string,
        chairPosition?: string,
        committeeMembers?: string,
        consulatePocCountryCallingCode?: number,
        consulatePocEmail?: string,
        consulatePocName?: string,
        consulatePocPhone?: string,
        countryId?: number,
        fcdoPostId?: number,
        instructions?: string,
        isOnline?: boolean,
        leadEmail?: string,
        leadName?: string,
        leadPosition?: string,
        municipality?: string,
        postalCode?: string,
        region?: string,
        regionId?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/interview-locations/{id}',
            path: {
                'id': id,
            },
            formData: {
                'chair_signature': chairSignature,
                'lead_signature': leadSignature,
                'letterhead': letterhead,
                'address_1': address1,
                'address_2': address2,
                'attendance_confirmation_email': attendanceConfirmationEmail,
                'attendance_confirmation_phone': attendanceConfirmationPhone,
                'chair_affiliation': chairAffiliation,
                'chair_email': chairEmail,
                'chair_name': chairName,
                'chair_position': chairPosition,
                'committee_members': committeeMembers,
                'consulate_poc_country_calling_code': consulatePocCountryCallingCode,
                'consulate_poc_email': consulatePocEmail,
                'consulate_poc_name': consulatePocName,
                'consulate_poc_phone': consulatePocPhone,
                'country_id': countryId,
                'fcdo_post_id': fcdoPostId,
                'instructions': instructions,
                'interview_location_name': interviewLocationName,
                'is_online': isOnline,
                'lead_email': leadEmail,
                'lead_name': leadName,
                'lead_position': leadPosition,
                'municipality': municipality,
                'postal_code': postalCode,
                'programme_id': programmeId,
                'region': region,
                'region_id': regionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get interview location committee members
     * @param id Interview location ID
     * @returns db_InterviewInterviewLocationCommitteeMember OK
     * @throws ApiError
     */
    public static getInterviewLocationCommitteeMembers(
        id: number,
    ): CancelablePromise<Array<db_InterviewInterviewLocationCommitteeMember>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-locations/{id}/committee-members',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an interview location document
     * @param id Interview location ID
     * @param documentType Document type
     * @returns binary OK
     * @throws ApiError
     */
    public static getInterviewLocationDocument(
        id: number,
        documentType: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-locations/{id}/documents/{document_type}',
            path: {
                'id': id,
                'document_type': documentType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update the active status of an interview location
     * @param id Interview location ID
     * @param body Is active status
     * @returns void
     * @throws ApiError
     */
    public static updateInterviewLocationIsActive(
        id: number,
        body: api_updateInterviewLocationIsActiveRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/interview-locations/{id}/is-active',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
